import { z } from 'zod';
import { commentMentionEntityTypeSchema } from '../notification-dto';
import { baseEmailDTOSchema } from './base-email-dto';

export const fimEmailSchemas = [
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('fim_magic_link'),
    data: z.object({
      verificationCode: z.string(),
      expiry: z.string(),
      logoUrl: z.url().optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('fim_invalid_email'),
    data: z.object({
      feedbackFormLink: z.url(),
      logoUrl: z.url().optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('feedback_submitted'),
    data: z.object({
      feedbackSummary: z.string(),
      feedbackDescription: z.string().optional(),
      feedbackFormName: z.string(),
      locale: z.string().optional(),
      actionUrl: z.string().url(),
      recipientName: z.string().optional(),
      notificationSettingsUrl: z.string().url().optional(),
      fields: z
        .array(
          z.object({
            name: z.string(),
            values: z.array(z.string()),
          }),
        )
        .optional(),
      attachments: z.array(z.string()).optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('idea_comment_notification'),
    data: z.object({
      commentText: z.string(),
      ideaTitle: z.string(),
      locale: z.string().optional(),
      actionUrl: z.string().url(),
      recipientName: z.string().optional(),
      notificationSettingsUrl: z.string().url().optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('comment_mention_notification'),
    data: z.object({
      entityType: commentMentionEntityTypeSchema.optional(),
      entityTitle: z.string(),
      commentText: z.string(),
      commenterName: z.string().optional(),
      locale: z.string().optional(),
      actionUrl: z.string().url(),
      recipientName: z.string().optional(),
      notificationSettingsUrl: z.string().url().optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('feedback_confirmation'),
    data: z
      .object({
        feedbackSummary: z.string().optional(),
        feedbackDescription: z.string().optional(),
        feedbackFormName: z.string(),
        contactName: z.string().optional(),
        viewFeedbackUrl: z.string().url(),
        portalLogoUrl: z.string().url().optional(),
        portalLogoData: z.string().optional(),
        portalLogoContentType: z.string().optional(),
        primaryColor: z.string().optional(),
        secondaryColor: z.string().optional(),
        unsubscribeUrl: z.string().url().optional(),
        fields: z
          .array(
            z.object({
              name: z.string(),
              values: z.array(z.string()),
            }),
          )
          .optional(),
        attachments: z.array(z.string()).optional(),
      })
      .refine(
        (data) => {
          const hasLogoData = data.portalLogoData !== undefined;
          const hasContentType = data.portalLogoContentType !== undefined;
          return hasLogoData === hasContentType;
        },
        {
          message: 'portalLogoData and portalLogoContentType must both be present or both absent',
        },
      ),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('stale_ideas_notification'),
    data: z.object({
      staleIdeasCount: z.number().positive(),
      ideaSamples: z.array(
        z.object({
          id: z.number(),
          title: z.string(),
        }),
      ),
      locale: z.string().optional(),
      actionUrl: z.string().url(),
      recipientName: z.string().optional(),
      notificationSettingsUrl: z.string().url().optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('idea_completion_notification'),
    data: z.object({
      body: z.string(),
      notificationSettingsUrl: z.string().url().optional(),
    }),
  }),
] as const;
